import axios from 'axios';

const API_URL = 'https://www.urbangis.mp.gov.in/ugpin/api/GisMphsDashboard';
const API_URL_LOCAL = 'https://localhost:5273/api/GisMphsDashboard';

export const getDashboardData = async () => {
  const response = await axios.get(API_URL);
 
  return response.data;
};
export const updateDashboardData = async (row) => {

    const response = await axios.put(
        `${API_URL}/${row.ulb_code}`,
        row
    );

    return response.data;
};

export const validateEditPassword = async (password) => {
   
     const response = await axios.post(
        `${API_URL}/ValidateEditPassword`,
        {
            password
        }
    );
    // const response =
    //     await axios.post(
    //         "https://localhost:5273/api/GisMphsDashboard/ValidateEditPassword",
    //         {
    //             password
    //         }
    //     );
   
    return response.data;
};